import * as React from "react";

/**
 * Skip to main content link for keyboard navigation accessibility.
 * Hidden by default, visible when focused via Tab key.
 */
export const SkipLink = () => (
  <a
    href="#main-content"
    className="sr-only focus:not-sr-only focus:fixed focus:z-[100] focus:top-4 focus:left-4 focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-md focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 font-medium"
  >
    Skip to main content
  </a>
);

export default SkipLink;
